import React from 'react';
import { useState } from 'react';
import { StandarPanel } from './StandarPanel';
import { PanelType } from '@fluentui/react';
export const StandarDataTableItem = function (props) {
    const [errors, setErrors] = useState({});
    return React.createElement(StandarPanel, { isOpen: true, type: props.panelType || PanelType.medium, headerText: props.title, hideAcceptButton: props.readonly, onAccept: () => {
            if (props.onValidate != null) {
                const result = props.onValidate(props.value);
                if (!result.isValid) {
                    setErrors(result.errors);
                    return;
                }
            }
            props.onAccept();
            props.onClose();
        }, onClose: () => props.onClose() }, props.onRender(errors, (values) => {
        props.onChanged(Object.assign(Object.assign({}, props.value), values));
    }));
};
